<div id="changeLangContentWrapper" class="content__wrapper language">
    <div id="changeLangCard" class="language_card">
        <div id="changeLangHeader" class="header">
            <img class="language_icon lang_image" alt="select language" />
            &nbsp; {{languageHeading}}
        </div>
        <div class="mb-3" id="changeLangDesc">
            {{languageDescription}}
        </div>
        <iposcen-spinner-overlay *ngIf="!showRetailGif" [isCard]="false" (getStatus)='isLoading = $event'></iposcen-spinner-overlay>
        <iposcen-spinner-overlay *ngIf="showRetailGif" [isCard]="true"></iposcen-spinner-overlay>
        <div id="changeLangSearchGroup" class="search_group">
            <div id="changeLangInputGroup" class="input-group">
                <input type="text" #searchValue [(ngModel)]="searchData" class="form-control"
                    (keyup.enter)="searchLanguageOnEnter(searchData)" [placeholder]="searchLanguageLabel" />
                <img class="search-clear-icon" alt="close" *ngIf="searchClose" (click)="clearSearch()" />
            </div>
            <button class="btn btn-primary search_btn gtmLanguageSearch" (click)="searchLanguageOnEnter(searchData)">
                <img class="search-icon" alt="search lang" />
            </button>
        </div>
        <div id="changeLangGroupObj" class="row row-height" [ngClass]="hasData ? 'languages_show' : 'languages_hide'">
            <div id="changeLangCol" class="col-xl-3 col-lg-4 col-sm-6" [ngClass]="{'resizeForm':isVietnamese, 'normalForm': !isVietnamese}"
                *ngFor="let language of languageJSON; trackBy: trackByLanguage">
                <label class="lang_radiobtn">
                    <input type="radio" name="langRadios" value="language.langName"
                        (click)="selectLanguage(language.langName, language.langCode)" [checked]="language.checked" />
                    {{ language.langName }}
                </label>
            </div>
        </div>
        <ng-container *ngIf="!hasData">
            <div id="changeLangLoading" class="center-text" *ngIf='!isLoading  else loading' i18n="@@active-users.expand.no-records-found">No Records Found</div>
            <ng-template #loading>
                <div [ngClass]="hasData ? 'languages_hide' : 'languages_show'">
                    <p class="center-text">{{globConst.LOADING}}</p>
                </div>
            </ng-template>
        </ng-container>
        <div id="changeLangbtn" class="button_wrapper">
            <button class="btn btn-primary btn-lg gtmLanguageSelect" (click)="changeLanguage()" [disabled]="isDisabled"
                *ngIf="hasData">
                {{selectLanguageLabel}}
            </button>
        </div>
    </div>
</div>

<div id="changeLangModalDialogCentered" class="modal-dialog-centered" *ngIf="isLanguageChanged">
    <div id="changeLangModalBackdrop" class="modal-backdrop show"></div>
    <div class="modal" id="myModal">
        <div id="changeLangModalDialog" class="modal-dialog">
            <div id="changeLangModalContent" class="modal-content">
                <div id="changeLangModalClose" class="removesuccessmodal-close-icon" data-dismiss="modal" (click)="closeModal()"></div>
                <div id="changeLangModalBody" class="modal-body">
                    <div id="changeLangModalImg" class="removesuccess_img_div text-center">
                        <span class="removesuccess_img"></span>
                    </div>
                    <div id="changeLangModalTitle" class="removesuccess-title text-center">
                        <span i18n="@@change-language.model-popup-heading.language-changed">Language Changed</span>
                    </div>
                    <div id="changeLangModalTitleContent" class="removesuccess-content text-center">
                        <span i18n="@@change-language.model-popup-desc.ipos-language-change-desc">IPOS language has been
                            successfully changed.</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
